import { Info } from "lucide-react";

const MedicalDisclaimer = () => (
  <div className="not-prose mt-10 rounded-xl border border-border p-5 bg-background/60" data-testid="medical-disclaimer">
    <div className="flex items-start gap-3">
      <Info size={16} strokeWidth={1.7} className="text-[hsl(var(--accent))] mt-0.5 shrink-0" />
      <div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--accent))] mb-1">Medical disclaimer</div>
        <p className="text-sm text-[hsl(var(--foreground))]/75 leading-relaxed">
          This article is for patient education. It is not a substitute for personalised medical advice,
          examination or diagnosis. If you have symptoms discussed here, please book an in-person consultation
          with a qualified ophthalmologist.
        </p>
      </div>
    </div>
  </div>
);

export default MedicalDisclaimer;
